import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const RoleForm = ({ open, onClose, onSubmit, initialData, title = 'Add Role', loading }) => {
  const [formData, setFormData] = useState({
    role_name: '',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        role_name: initialData.role_name || '',
      });
    } else {
      setFormData({ role_name: '' });
    }
    setErrors({});
  }, [initialData, open]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.role_name.trim()) {
      newErrors.role_name = 'Role name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const payload = { ...formData };
    if (initialData?.id) payload.id = initialData.id;
    await onSubmit(payload);
  };

  const handleClose = () => {
    if (loading) return;
    setFormData({ role_name: '' });
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {title}
          <IconButton onClick={handleClose} size="small" disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box component="form" sx={{ mt: 1 }}>
          <TextField
            fullWidth
            margin="normal"
            label="Role Name"
            value={formData.role_name}
            onChange={handleChange('role_name')}
            error={!!errors.role_name}
            helperText={errors.role_name}
            required
            disabled={loading}
            placeholder="e.g., Admin, Teacher, Parent"
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading} startIcon={loading ? <CircularProgress size={16} /> : null}>
          {initialData?.id ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoleForm;

